import React, { useState, useEffect, useRef } from "react"
import { disableBodyScroll, enableBodyScroll } from '../../body-scroll-lock'
// import Cookies from "js-cookie";
import Loading from './Loading'
import Form from './Form'
import Purchase from './types/Purchase'
import Vendor from './types/Vendor'
import Product from './types/Product'

export default function App() {
  // const baseUrl = window.location.host === "dev-megaphone-wordpress.pantheonsite.io" ? "https://megaphone-magazine-staging-d857d30ff8e7.herokuapp.com" : "http://localhost:3000"
  const baseUrl = "https://app.megaphonemagazine.com";
  const clientSecret = new URLSearchParams(window.location.search).get("payment_intent_client_secret")
  const [loading, setLoading] = useState<boolean>(true)
  const [open, setOpen] = useState<boolean>(!!clientSecret || (window.location.hash === '#buy'))
  const [error, setError] = useState<null | string>(null)
  const modalRef = useRef<HTMLDivElement>(null)
  
  const [purchase, setPurchase] = useState<Purchase | undefined>(undefined)
  const [vendors, setVendors] = useState<Vendor[]>([])
  const [products, setProducts] = useState<Product[]>([])

  useEffect(() => {
    Promise.all([
      fetch(baseUrl + "/vendors.json"),
      fetch(baseUrl + "/products.json?web=true"),
    ])
    .then((responses) => {
      const errors = responses.filter((response) => !response.ok);
      if (errors.length > 0) {
        throw errors.map((response) => Error(response.statusText));
      }
      const json = responses.map((response) => response.json());
      return Promise.all(json);
    })
    .then((data) => {
      setLoading(false)
      setVendors(data[0])
      setProducts(data[1])
    })
    .catch((errors) => {
      setLoading(false)
      setError("Something went wrong fetching the vendors or products.")
    });
  }, [])

  useEffect(() => {
    if (modalRef && modalRef.current) {
      if (open) {
        disableBodyScroll(modalRef.current)
      }
      else {
        enableBodyScroll(modalRef.current)
      }
    }
  }, [modalRef, open])

  useEffect(() => {
    window.addEventListener('keydown', downHandler)
    return () => {
      window.removeEventListener('keydown', downHandler)
    }
  }, [])

  const openModal = () => {
    setOpen(true)
  }
  const closeModal = () => {
    setOpen(false)
  }
  const downHandler = (e: KeyboardEvent) => {
    if (e.code === 'Escape') {
      closeModal()
    }
  }

  return (
    <>
      <button
        className="button button--rounded"
        onClick={openModal}
        aria-haspopup="dialog"
        aria-expanded={open}
      >
        Pay a Vendor
      </button>
      <div
        ref={modalRef}
        className={`modal modal-donate modal-donate-next ${open ? 'show' : ''}`}
        tabIndex={-1}
        role="dialog"
        aria-hidden={!open}
        aria-labelledby="modal-title"
      >
        <div className="modal-backdrop" aria-hidden="true" onClick={closeModal}></div>
        <div className="modal-contents">
          <button
            type="button"
            className="modal-close"
            onClick={closeModal}
            aria-label="Close"
          >
            Close
          </button>
          {!loading ? (
            <div style={{ display: open ? 'block' : 'none' }}>
              {error && <div className="error">{error}</div>}
              <Form
                vendorsInitial={vendors}
                productsInitial={products}
                closeModal={closeModal}
                openModal={openModal}
                isModalOpen={open}
                baseUrl={baseUrl}
                purchase={purchase}
                setPurchase={setPurchase}
                modalRef={modalRef}
              />
            </div>
            ) : (
              <Loading />
          )}
        </div>
      </div>
      {!open && purchase && (
        <div className="purchase-alert">
          <div className="purchase-alert-inner">
            <div>
            You paid <strong>{purchase.vendor.name}</strong>
            </div>
            <button
              className=""
              onClick={openModal}
              aria-haspopup="dialog"
              aria-expanded={open}
              >
              Show
            </button>
          </div>
        </div>
      )}
    </>
  )
}